module.exports = __webpack_public_path__ + "img/hr-garballo-17.cf4a2352.png";